<template>
  <div>
    <v-snackbar v-model="snackbar" timeout="3000" right top :color="snackbarColor">{{ text }}</v-snackbar>
    <v-dialog v-model="dialog" max-width="500px" v-if="hasRole(AdminUserPermissions.SHOP_ORDER_UPDATE)">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" small color="primary" class="text-capitalize">
          <v-icon small>mdi-check-circle-outline</v-icon>
          Deliver Order</v-btn
        >
      </template>
      <v-card class="pt-1 pb-5" color="pop_bg">
        <v-card-text class="subtitle-1 mb-0 mt-6 text-center dark--text">
          Mark As Delivered
        </v-card-text>

        <div wrap class="mx-0 px-0 d-flex justify-center">
          <v-icon size="100">mdi-truck-delivery</v-icon>
        </div>

        <v-card-text v-if="error" class="error--text font-weight-bold">{{ error }}</v-card-text>
        <v-card-actions justify="center" class="mt-8">
          <v-row justify="center">
            <v-btn color=" mx-2 error" depressed @click="close">No</v-btn>
            <v-btn color=" mx-2 success" depressed :loading="btnloading" @click="cancelOrder()">Yes</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      required: true,
    },
  },

  data() {
    return {
      dialog: false,
      btnloading: false,
      show_alert: false,
      error: null,
      snackbar: false,
      snackbarColor: "",
      text: "",
      drivers: [],
      driverOrders: [],
      driver: "",
      loading: false,
    };
  },
  methods: {
    cancelOrder() {
      this.btnloading = true;
      this.$apollo
        .mutate({
          mutation: require("../api/updateOrderStatuses.graphql"),
          variables: {
            ids: [this.item._id],
            status: "DELIVERED",
            deliveryText: "",
          },
        })
        .then(data => {
          this.btnloading = false;
          this.$root.$emit("getAllOrders");
          if (data.data.updateOrderStatuses) {
            this.dialog = false;
            this.text = "Order Delvierd.";
            this.snackbarColor = "success";
            this.snackbar = true;
          }
        })
        .catch(error => {
          console.log(error);
          this.btnloading = false;
          this.text = "Something went wrong";
          this.snackbarColor = "error";
          this.snackbar = true;
          this.dialog = false;
        });
    },

    close() {
      this.error = null;
      this.dialog = false;
    },
  },
};
</script>
